import { BOTANIX, ASSETCHAIN, ASSETCHAIN_TESTNET, ETH_MAINNET } from "./chains";
import { isDevelopment } from "./env";
import { getSubgraphUrlKey } from "./localStorage";

const SUBGRAPH_URLS = {
  [BOTANIX]: {
    subsquid: "https://gmx.squids.live/gmx-synthetics-botanix:prod/api/graphql",
    stats: "https://subgraph.satsuma-prod.com/3b2ced13c8d9/gmx/synthetics-botanix-stats/api",
    syntheticsStats: "https://subgraph.satsuma-prod.com/3b2ced13c8d9/gmx/synthetics-botanix-stats/api",
  },

  [ASSETCHAIN]: {
    subsquid: import.meta.env.VITE_SUBSQUID_URL_ASSETCHAIN,
    stats: import.meta.env.VITE_STATS_SUBGRAPH_URL_ASSETCHAIN,
    syntheticsStats: import.meta.env.VITE_SYNTHETICS_STATS_SUBGRAPH_URL_ASSETCHAIN,
  },

  [ASSETCHAIN_TESTNET]: {
    subsquid: import.meta.env.VITE_SUBSQUID_URL_ASSETCHAIN_TESTNET,
    stats: import.meta.env.VITE_STATS_SUBGRAPH_URL_ASSETCHAIN_TESTNET,
    syntheticsStats: import.meta.env.VITE_SYNTHETICS_STATS_SUBGRAPH_URL_ASSETCHAIN_TESTNET,
  },

  common: {
    [ETH_MAINNET]: {
      chainLink: "https://api.thegraph.com/subgraphs/name/deividask/chainlink",
    },
  },
};

export function getSubgraphUrl(
  chainId: number,
  subgraph: "stats" | "referrals" | "nissohVault" | "syntheticsStats" | "subsquid" | "chainLink"
): string | undefined {
  if (isDevelopment()) {
    const localStorageKey = getSubgraphUrlKey(chainId, subgraph);
    const url = localStorage.getItem(localStorageKey);
    if (url) {
      // eslint-disable-next-line no-console
      console.warn("%s subgraph on chain %s url is overriden: %s", subgraph, chainId, url);
      return url;
    }
  }

  if (chainId === ETH_MAINNET) {
    return SUBGRAPH_URLS.common[ETH_MAINNET]?.[subgraph];
  }

  return SUBGRAPH_URLS?.[chainId]?.[subgraph];
}
